import React, { useState, useEffect } from "react";
import TextField from "../../Utils/FormInputs/TextField";
import config from "../../Helpers/config.json";

export default function ProductSearch() {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [isFocused, setIsFocused] = useState(false); // track focus

  const fetchProducts = async (term) => {
    if (!term.trim() || !isFocused) return; // don't fetch if blurred
    try {
      const res = await fetch(
        `${config.epharmUrl}/Cproduct/find_product_details?search=${term}`
      );
      const data = await res.json();
      if (isFocused) {
        setResults(data);
        setShowResults(true);
      }
    } catch (err) {
      console.error("Error fetching product details:", err);
    }
  };

  useEffect(() => {
    if (!isFocused) return;
    const delayDebounce = setTimeout(() => {
      fetchProducts(searchTerm);
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm, isFocused]);

  // 👇 auto-hide after 5 seconds
  useEffect(() => {
    if (showResults) {
      const timer = setTimeout(() => {
        setShowResults(false);
      }, 90000);
      return () => clearTimeout(timer); // cleanup if unmounted or results change
    }
  }, [showResults]);

  const handleChangeSearch = (e) => setSearchTerm(e.target.value);

  return (
    <div className="search-section relative w-full">
      <TextField
        type="text"
        placeholder="Search product..."
        value={searchTerm}
        onChange={handleChangeSearch}
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          setIsFocused(false);
          setShowResults(false);
        }}
      />

      {/* Results panel */}
      {showResults && results.length > 0 && (
        <div
          className="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded shadow-lg max-h-80 overflow-y-auto"
          style={{ boxShadow: "0px 4px 6px rgba(0,0,0,0.1)" }}
        >
          <table className="table-auto border-collapse w-full">
            <thead className="sticky top-0 bg-gray-100">
              <tr>
                <th className="border p-2 text-left">Product Name</th>
                <th className="border p-2 text-left">Generic</th>
                <th className="border p-2 text-left">Strength</th>
                <th className="border p-2 text-left">Batch</th>

                <th className="border p-2 text-left">Unit</th>
                <th className="border p-2 text-left">Retail Price</th>
                <th className="border p-2 text-left">Wholesale Price</th>
                <th className="border p-2 text-left">Stock</th>
                <th className="border p-2 text-left">Location</th>
                <th className="border p-2 text-left">Last Purchase Price</th>
              </tr>
            </thead>
            <tbody>
              {results.map((item) => (
                <tr
                  key={item.product_id}
                  className="hover:bg-gray-50 cursor-pointer"
                >
                  <td className="border p-2">{item.product_name}</td>
                  <td className="border p-2">{item.generic_name}</td>
                  <td className="border p-2">{item.strength}</td>
                  <td className="border p-2">{item.batch_number}</td>
                  <td className="border p-2">{item.unit}</td>
                  <td className="border p-2">
                    {item.retail_price <= 0 ? item.price : item.retail_price}
                  </td>
                  <td className="border p-2">{item.wholesale_price}</td>

                  <td className="border p-2">{item.stock}</td>
                  <td className="border p-2">{item.product_location}</td>
                  <td className="border p-2">{item.last_purchase_price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
